export enum ModelView {
    ADD_USER_TO_GROUP,
    REM_USER_FROM_GROUP,
    CREATE_GROUP,
    UPDATE_GROUP,
    DELETE_GROUP,
    DELETE_BUSINESS_UNIT,
    CREATE_BUSINESS_UNIT,
    EDIT_BUSINESS_UNIT
}